module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-text', [_c('div', {
    staticClass: "v-header"
  }, [_vm._v(_vm._s(_vm.$t('message.labelTodaysPrediction')) + " "), _c('mu-icon', {
    attrs: {
      "value": "help"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelTodaysPredictionExplain')))])]), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "center-text",
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('radial-progress', {
    attrs: {
      "mode": "duration",
      "data-id": "radial-loading-1",
      "value": _vm.$store.state.cards.sleep.wearable.minutesAwake,
      "outOfValue": _vm.$store.state.cards.sleep.wearable.predictions.minutesAwake,
      "suffix": "min",
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelTimeAwake')[0].toUpperCase() + _vm.$t('message.labelTimeAwake').substr(1)))])], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "center-text",
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('radial-progress', {
    attrs: {
      "mode": "duration",
      "data-id": "radial-loading-3",
      "value": _vm.$store.state.cards.sleep.wearable.minutesAsleep,
      "outOfValue": _vm.$store.state.cards.sleep.wearable.predictions.minutesAsleep,
      "suffix": "min",
      "color": "#89C93B"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.labelTimeAsleep')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74032694","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Visualizations/Sleep/SleepVisualisation.vue
// module id = 3228
// module chunks = 1